import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';

const copyText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  // Plain-http admin hosts have no Clipboard API.
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  document.execCommand('copy');
  document.body.removeChild(area);
};

// A value shown in full (wrapping) with a copy button next to it.
const CopyValue = ({ value, label, code = true }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(t);
  }, [copied]);

  if (value === null || value === undefined || value === '') {
    return <span className="text-muted">—</span>;
  }

  const onCopy = async () => {
    try {
      await copyText(String(value));
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="apple-transfer-copy">
      {code ? <code className="apple-transfer-copy__value">{value}</code> : <span className="apple-transfer-copy__value">{value}</span>}
      <Button
        size="sm"
        variant="outline-secondary"
        className="apple-transfer-copy__button"
        onClick={onCopy}
        aria-label={`Copy ${label}`}
        title={`Copy ${label}`}
      >
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} className="me-1" />
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </div>
  );
};

export default CopyValue;
